import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { MdDialog } from '@angular/material';
import { ApplyStatusService } from '../../services/apply-status.service';
import {MdCheckboxModule} from '@angular/material';
import { DocListAnswerService } from '../../services/doc-list-answer.service';
import { ApplyService } from '../../services/apply.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Constants } from '../constants';

@Component({
  selector: 'app-check-docs',
  templateUrl: './check-docs.component.html',
  styleUrls: ['./check-docs.component.css']
})
export class CheckDocsComponent implements OnInit {

  jobId: string;
  userId: string;
  job: JobsOffer;
  viewinvite: boolean;
  invitations: any;
  checked: number[] = [];
  comments: string[] = [];
  docid: string[] = [];
  docuserid: string[] = [];
  user: any;

  doclist:any;

  errorMessage: string;

  loading_job: boolean;

  public STATUS = Constants;

  doc_status = [
    {
      key: '-1',
      value:'Rechazado'
    },
    {
      key: '1',
      value:'Pendiente'
    },
    {
      key: '3',
      value:'Reenviar'
    },
    {
      key: '2',
      value:'Aprobado'
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,
    private dialog: MdDialog,
    private router: Router,
    private applyStatusService: ApplyStatusService,
    private ApplyService: ApplyService,
    private docListAnswerService: DocListAnswerService
  ) { }

  ngOnInit() {
    // TODO: get users invite to jobId

    this.loading_job = true;
    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];
      this.userId = params['userId'];
    });
    this.jobService.getOffersById(this.jobId).subscribe(
      data => {
        this.job = data;
        this.loading_job = false;
      },
      error => {
        this.errorMessage = <any>error;
        this.loading_job = false;
      }
    );
      this.ApplyService.getApply(this.userId, 1 ,1).subscribe(
        data => {
          this.user = data.applicants[0];
          this.loading_job = false;
        },
        error => {
          this.errorMessage = <any>error;
          this.loading_job = false;
        }
      );
      this.docListAnswerService.getDocList(this.jobId, this.userId).subscribe((data:any) => {
        data.doclist.docs.forEach((element, index) => {
          this.checked[index] = element.status;
          this.docid[index] = element.id;
          this.docuserid[index] = element.id_userdoc;
          this.comments[index] = element.comment;
        });
        this.doclist = data.doclist;
      });
  }

  // sendCheck(doclist_id, check, comment, docid, userdocid){
  sendCheck(){
    this.docListAnswerService.putDocAnswerStatus(this.user.job.id, this.doclist.id, this.checked, this.comments, this.docid, this.docuserid).subscribe((data:any) => {
      this.docListAnswerService.getDocList(this.jobId, this.userId).subscribe((data:any) => {
        data.doclist.docs.forEach((element, index) => {
          this.checked[index] = element.status;
          this.docid[index] = element.id;
          this.docuserid[index] = element.id_userdoc;
          this.comments[index] = element.comment;
        });
        let md = this.dialog.open(MessageBoxDialog, {data: {message: 'Datos Guardados', success: true, showIcon:true}});
        md.afterClosed().subscribe(result => {
          this.router.navigate(['/pages/checkdoclist']);
        });
        this.doclist = data.doclist;
      });
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/check-docs/check-docs.component.ts